import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ZenSpinner from '../components/ZenSpinner';

const AdminRoute = ({ children }) => {
  const { currentUser, isLoading } = useAuth();

  if (isLoading) {
    return <ZenSpinner />;
  }

  if (!currentUser) {
    return <Navigate to="/today" />;
  }

  if (currentUser.role !== 'admin') {
    return <Navigate to="/" />;
  }

  return children;
};

export default AdminRoute;
